/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StatusChangedAt/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import SupportOnly from 'DesignSystem/SupportOnly/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function StatusChangedAt({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/PaymentProviders/Accounts/Content/ProviderAccount/StatusChangedAt"
  
}) {
let providerAccountStatusChangedAtValueData = fromData.useDataFormat({ viewPath,
context: 'provider_account',
path: 'status_changed_at',
format: fromFormat.dateISOToDateAndTime,
})
  return (<React.Fragment
>
<SupportOnly
  viewPath={`${viewPath}/SupportOnly`}
>
{childProps => (
<div
  data-testid="StatusChangedAt.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="provider_account.status_changed_at"
 format="/Data/format.js dateISOToDateAndTime"
 text={providerAccountStatusChangedAtValueData}
/>
</div>
)}
</SupportOnly>
{children}
</React.Fragment>)
}